import React from 'react';
import { Modal } from 'antd';
import ButtonML from '@/components/button_ml/ButtonML';
import { useTrigger } from '@/utils/comHook.js';
import Children from './Children';
/**
 * 头部OK按钮
 * @param {*} param
 */
const ModalML = (props) => {
  const trigger = useTrigger();
  let {
    value,
    htmlType,
    size,
    fontsize,
    title,
    okText,
    cancelText,
    handleOk,
    disabled,
  } = props;

  const handleCancel = () => {
    trigger.close();
  };
  const handleOkUse = () => {
    handleOk();
    trigger.close();
  };

  return (
    <div>
      <ButtonML
        size={size ? size : 'large'}
        value={value}
        htmlType={htmlType}
        fontsize={fontsize ? fontsize : '16px'}
        disabled={disabled}
        // onClick={confirm}
        onClick={trigger.open}
      />
      <Modal
        title={null}
        centered={true} // 垂直居中展示modal
        visible={trigger.visible}
        onOk={handleOk}
        footer={null}
        closable={false}
      >
        <Children
          title={title}
          okText={okText}
          cancelText={cancelText}
          handleOk={handleOkUse}
          handleCancel={handleCancel}
        />
      </Modal>
    </div>
  );
};

export default ModalML;
